const pre = 'SETTINGS/';

export const USER_PROFILE_LOADED = `${pre}USER_PROFILE_LOADED`;
export const SET_USER_PROFILE_LOADING = `${pre}SET_USER_PROFILE_LOADING`;
export const SET_USER_ROLE = `${pre}SET_USER_ROLE`;
export const SET_USER_INFO = `${pre}SET_USER_INFO`;
export const SET_USER_PROFILE_INITIALISED = `${pre}SET_USER_PROFILE_INITIALISED`;
export const APP_CONFIG_LOADED = `${pre}APP_CONFIG_LOADED`;
export const SET_APP_CONFIG = `${pre}SET_APP_CONFIG`;

export const UserProfileConnected = () => ({ type: USER_PROFILE_LOADED });
export const setUserProfileLoading = loading => ({ type: SET_USER_PROFILE_LOADING, loading });
export const setUserRole = (role) => ({ type: SET_USER_ROLE, role });
export const setUserInfo = (info) => ({ type: SET_USER_INFO, info });
export const setUserProfileInitialised = initialised => ({ type: SET_USER_PROFILE_INITIALISED, initialised });
export const AppConfigConnected = () => ({ type: APP_CONFIG_LOADED });
export const setAppConfig = (data) => ({ type: SET_APP_CONFIG, data });

export const APP_CONFIG_SAVE_REQUESTED = `${pre}APP_CONFIG_SAVE_REQUESTED`;
export const SET_APP_CONFIG_SAVING = `${pre}SET_APP_CONFIG_SAVING`;
export const SET_APP_CONFIG_SAVE_ERROR = `${pre}SET_APP_CONFIG_SAVE_ERROR`;
export const SET_APP_CONFIG_SAVED = `${pre}SET_APP_CONFIG_SAVED`;

export const saveAppConfig = (data) => ({ type: APP_CONFIG_SAVE_REQUESTED, data });
export const setAppConfigSaving = (saving) => ({ type: SET_APP_CONFIG_SAVING, saving });
export const setAppConfigSaveError = (error) => ({ type: SET_APP_CONFIG_SAVE_ERROR, error });
export const setAppConfigSaved = (saved) => ({ type: SET_APP_CONFIG_SAVED, saved });
